<template>
  <div ref="top" class="mobile-content">
    <div
      v-if="showParticipateBtn"
      :class="cssTheme"
      class="mobile-grid-wrapper"
    >
      <div class="m-3 text-center">
        <Btn :label="labelParticipateBtn" @click.native="onParticipate" />
      </div>
    </div>

    <div
      v-if="isHiddenPoll"
      :class="aligmentCss"
      class="d-flex mx-3 text-weight-semi-bold"
    >
      <div
        class="info-content text-size-14 flex-row mobile-info-wrapper"
        :class="cssTheme"
      >
        <div class="mx-1">
          <font-awesome-icon class="mx-1" :icon="['fas', 'info-circle']" />
          {{ msgHiddenPoll }}
        </div>
      </div>
    </div>

    <div ref="responses" :class="cssTheme" class="mobile-grid-wrapper">
      <div class="mx-3 text-weight-semi-bold">
        <Header :textColor="textColor">
          <div class="d-flex justify-content-between w-100">
            <div class="d-flex align-items-center text-size-18">
              <font-awesome-icon class="mr-1" :icon="['fas', 'check']" />
              {{ responsesHeadline }}
              <span
                v-if="isOwner"
                v-on:click="enterNewParticipant()"
                class="text-primary ml-2"
              >
                <font-awesome-icon :icon="['fas', 'plus-circle']" />
              </span>
            </div>

            <div v-if="!isHiddenPoll" class="d-flex">
              <font-awesome-icon
                @click="setDesktopView()"
                class="ml-2 pointer text-primary"
                :icon="['fal', 'table']"
              />
            </div>
          </div>
        </Header>
      </div>

      <div
        v-if="pollInfoMessage"
        :class="aligmentCss"
        class="d-flex text-weight-semi-bold"
      >
        <div
          :style="gridTheme"
          :class="[pollInfoMessage.class, cssTheme]"
          class="legend-content text-size-14 flex-row"
        >
          <div class="mx-1">
            <font-awesome-icon class="mx-1" :icon="pollInfoMessage.icon" />
            {{ pollInfoMessage.text }}
          </div>
        </div>
      </div>

      <render-hidden-mode-participant-mobile
        v-if="0 && isHiddenPoll"
        :adminName="poll.user_name"
        :isOwner="isOwner"
        :isDarkMode="isDarkMode"
        :type="polltype(poll.type)"
      />

      <component
        @startEditParticipant="startEditParticipant"
        @next="onNext"
        @previous="onPrevious"
        :initParticipant="curParticipant"
        :isDarkMode="isDarkMode"
        :submittingParticipant="submittingParticipant"
        @editSubmittingParticipant="onEditButtonClick"
        @resetSubmittingParticipant="whenResetSubmittingParticipant"
        v-bind:is="currentTabComponent"
        ref="renderMobileParticipantsRef"
        v-if="loadingComplete"
      ></component>
    </div>

    <div
      v-if="showTasks"
      id="tasks"
      ref="tasks"
      :style="gridTheme"
      :class="cssTheme"
      class="mobile-task-wrapper"
    >
      <renderTasks :isDarkMode="isDarkMode"></renderTasks>
    </div>

    <div
      v-if="showComments"
      ref="comments"
      :class="cssTheme"
      class="mobile-grid-wrapper"
    >
      <renderComments
        :isDarkMode="isDarkMode"
        :allowComments="!displayCommentTaskNavigationPanel"
      ></renderComments>
    </div>

    <div class="mobile-bottom-space"></div>

    <a v-if="0" @click="enterNewParticipant" href="#" class="float">
      <font-awesome-icon class="my-float" :icon="['fal', 'plus']" />
    </a>

    <NavigationButtons
      :displayTask="showTasks"
      :displayComment="showComments"
      :displayNavigationButtons="displayCommentTaskNavigationPanel"
      @whenClicked="startScrollWhenClicked"
    >
    </NavigationButtons>

    <ModalParticipant
      ref="newParticipantModal"
      :user="user"
      :invitation="invitation"
      :edit-mode="modalEditMode"
      :edit-participant="editParticipant"
      @save="onSaveModal"
      @cancel="stopEditParticipant"
    >
    </ModalParticipant>
    <ModalSameEmailDialog
      ref="dlgParticipantsWithSameEmail"
      :participantsWithSameEmail="existingParticipants"
      :participantData="participantData"

    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import renderParticipants from './RenderMobileParticipants';
import renderInvitations from './RenderMobileInvitations';
import renderComments from './RenderMobileComments';
import renderTasks from './RenderMobileTasks';
import NavigationButtons from './NavigationButtons.vue';

import NavigationTabs from '@/components/UI/NavigationTabs';
import Header from '@/components/Rendering/RenderMobileHeader.vue';

import ModalParticipant from '@/components/UI/ModalParticipant';
import RenderHiddenModeParticipantMobile from '@/components/Rendering/RenderHiddenModeParticipantMobile';
import ModalSameEmailDialog from './ModalSameEmailDialog.vue';

import { renderMixin } from '../mixins/RenderMixins';
import { gridMixin } from '../mixins/GridMixins';
import { themeMixin } from '../mixins/ThemeMixins';
import { deviceMixin } from '../mixins/DeviceMixins';
import { pollMixin } from '../mixins/PollMixins.js';
import { modalParticipantMixins } from '../mixins/ModalParticipantMixins';
import sortParticipants from '@/shared/sortParticipants';
import { constants } from '@/shared/constant';

export default {
  name: 'RendererDataMobile',
  mixins: [
    renderMixin,
    themeMixin,
    gridMixin,
    deviceMixin,
    modalParticipantMixins,
    pollMixin,
  ],
  data() {
    return {
      curParticipant: 0,
      currentTab: 0,
      currentTabComponent: 'render-participants',
      modalEditMode: false,
      editParticipant: null,
      dlgChoiceDialog: null,
      submittingParticipant: null,
      loadingComplete: false,
      displayCommentTaskNavigationPanel: true,
      participantData: null,
    };
  },

  components: {
    renderParticipants,
    renderComments,
    renderTasks,
    renderInvitations,
    ModalParticipant,
    NavigationTabs,
    RenderHiddenModeParticipantMobile,
    Header,
    NavigationButtons,
    ModalSameEmailDialog,
  },

  watch: {
    'poll.participants': {
      deep: true,
      handler() {
        this.currentParticipant = this.getCurrentParticipant();
      },
    },
  },

  methods: {
    getClassBasedOnChoice() {
      this.$refs.renderMobileParticipantsRef.compareChoices();
    },
    setDesktopView() {
      console.log('Set mobile view deviceWidth:', this.deviceWidth);

      const viewportContent =
        this.deviceWidth > constants.mobileBreakpoint
          ? 'width=device-width  initial-scale=1.0'
          : 'width=device-width initial-scale=0.8';
      document
        .querySelector("meta[name='viewport']")
        .setAttribute('content', viewportContent);

      this.$nextTick(() => {
        this.$store.commit('setMobileView', false);
      });
    },

    onNext() {
      this.curParticipant++;
    },

    onPrevious() {
      this.curParticipant--;
    },

    startEditParticipant() {
      console.log('startEditParticipant was activated');
      if (!this.isEditable(this.participant)) {
        console.log('current participant not editable');
        return;
      }

      this.editParticipant = this.participant;
      this.modalEditMode = true;
      this.$refs.newParticipantModal.openModal();
    },
    onEditButtonClick(event) {
      this.submittingParticipant = event.participant;
      this.displayCommentTaskNavigationPanel = !event.isChoicesInEditMode;
    },
    whenResetSubmittingParticipant() {
      this.submittingParticipant = null;
      this.displayCommentTaskNavigationPanel = true;
    },
    startScrollWhenClicked($event) {
      this.goto($event);
    },
  },
  computed: {
    ...mapState({
      poll: (state) => state.poll.poll,
      userId: (state) => state.Login.userId,
      ownerId: (state) => state.poll.poll.user.id,
      keyUserId: (state) => state.keyUserId,
      curInvitation: (state) => state.curInvitation,
    }),

    ...mapGetters([
      'user',
      'isAuthenticated',
      'isOwner',
      'publicKey',
      'isPollEditable',
      'userId',
      'isPublicLink',
      'isAdminLink',
      'isPollEditable',
    ]),

    showNavigation() {
      if (this.isHiddenParticipantMode) return false;
      return true;
      //if( this.showComments) return true;
      // return false;
    },

    isDarkMode() {
      if (this.poll.options.darkMode) return true;
      return false;
    },

    cssTheme() {
      var isFirefox = typeof InstallTrigger !== 'undefined';
      console.log({ isFirefox });
      if (this.isDarkMode) {
        if (isFirefox) {
          return 'dark-mode dark-mode-bg-ff';
        }
        return 'dark-mode dark-mode-bg';
      }
      if (isFirefox) {
        return 'light-mode light-mode-bg-ff';
      }
      return 'light-mode light-mode-bg';
    },

    navItems() {
      const itemParticipants = {
        code: 'render-participants',
        label:
          this.participantCount + '<br/>' + this.$t('polls.navParticipant'),
      };
      let items = [];
      items.push(itemParticipants);

      if (this.showComments) {
        const itemComments = {
          code: 'render-comments',
          label: this.commentsCount + '<br/>' + this.$t('polls.navComments'),
        };
        items.push(itemComments);
      }
      return items;
    },

    // participants() {
    //   console.log('participants: ', this.poll.participants);
    //   let participants = this.poll.participants;
    //   return participants;
    // },

    invitesCount() {
      if (!this.openInvitations) return 0;
      return this.openInvitations.length;
    },

    // participantCount() {
    //   return this.participants.length;
    // },

    participant() {
      return this.participants[this.curParticipant];
    },
    participantName() {
      return this.participants[this.curParticipant].name;
    },
  },
  mounted() {
    /* iOS re-orientation fix */
    this.dlgChoiceDialog = this.$refs.dlgChoiceDialog;
    if (
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPad/i)
    ) {
      /* iOS hides Safari address bar */
      // window.addEventListener('load', function () {
      //   setTimeout(function () {
      //     window.scrollTo(0, 1);
      //   }, 1000);
      // });
    }

    // make sure that the current user is on the top of the list
    console.log('(RenderDataMobile) cur invitation:', this.curInvitation);

    const viewportContent = 'width=device-width initial-scale=1';
    document
      .querySelector("meta[name='viewport']")
      .setAttribute('content', viewportContent);

    let participants = this.identifyCurrentUser(this.poll.participants);
    console.log('(RenderDataMobile) participants:', participants);
    // make sure that the current user is on the top of the list
    sortParticipants(participants, this.userId);
    this.$store.commit('updateParticipants', participants);

    this.currentParticipant = this.getCurrentParticipant();
    console.log(
      'RenderDataMobile - mounted(currentParticipant) ==> ',
      this.currentParticipant
    );

    if (this.isAnswerEditable(this.currentParticipant)) {
      this.submittingParticipant = this.currentParticipant;
    }

    this.loadingComplete = true;
    if (this.currentParticipant) {
      return;
    }
    const doEnterNewParticipant = this.isNewParticipantRequired();
    if (doEnterNewParticipant) {
      this.enterNewParticipant(true);
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/colors';

.mr-2.mt-1.text-center {
  max-width: 500px;
  word-break: break-word;
}

.mobile-task-wrapper {
}

// .my-float {
//   margin-top: 13px;
//   font-size: 1.2rem;
// }
</style>
